import { JustpayProductMovementEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-productmovement-endpoint-service"

export class JustpayProductMovementService {
    constructor () {
        this.justpayProductMovementEndpointService = new JustpayProductMovementEndpointService()
    }

    async changeProductMovement (request) {
        await this.justpayProductMovementEndpointService.changeProductMovement(request)
    }

    async createProductMovement (request) {
        await this.justpayProductMovementEndpointService.createProductMovement(request)
    }

    async getProductMovement (taskId) {
        const response = await this.justpayProductMovementEndpointService.getProductMovements({ id: taskId })
        response.data = response.data.length > 0 ? response.data[0] : {}
        return response
    }

    async getProductMovements (arg) {
        return this.justpayProductMovementEndpointService.getProductMovements(arg)
    }

    async conductProductMovement (request) {
        await this.justpayProductMovementEndpointService.conductProductMovement(request)
    }
}
